import {Section} from './section'

export class Assessment {
  id: string | null = null
  date: string | null = null
  score: number = 0
  sections: Array<Section> = []
}
